import { StorageOfferResource } from 'app/storage-offer/storage-offer.resource';
import { AuthService } from 'app/_services/auth.service';
import * as angular from 'angular';
import { config } from 'angular/utils/config';

class StorageOfferBidsComponentCtrl implements ng.IController {
    public offer: StorageOfferDto;
    public offerBids: StorageOfferBidDto[];
    public toggleEdit: Function;
    public cancelEditOfferBids: Function;
    public submitEditOfferBids: Function;
    public sortColumn: string = 'timestamp';
    public sortAscending: boolean = false;
    public deletionError: boolean = false;
    public deletionErrMsg: string;
    public loggedInUser: LoginResult;
    public deletionLoading: boolean = false;
    public deletionSuccess: boolean = false;
    public longTermContractsVisible: boolean = false;
    public allocationsVisible: boolean;
    public allocationEditModeActive: boolean;
    public allocationEditDisabled: boolean;
    public editBidId: string;
    public appBaseUrl = config.appBaseUrl;

    public readonly deletionEventName = {
        SUCCESS: 'deletion-success-event',
        ERROR: 'deletion-error-event'
    };
    public bidType: 'bid' | 'pre-bid';
    public refreshBids: () => ng.IPromise<any>;

    constructor(
        private $window: ng.IWindowService,
        private $location: ng.ILocationService,
        private $anchorScroll: ng.IAnchorScrollService,
        private $timeout: ng.ITimeoutService,
        private $rootScope: ng.IRootScopeService,
        private storageOfferResource: StorageOfferResource,
        private authService: AuthService
    ) {}

    $onInit(): void {
        if (this.offer.state == 'PUBLISHED' && this.offer.currentRound === 1) {
            this.bidType = 'pre-bid';
        } else {
            this.bidType = 'bid';
        }
        this.getBids();
    }

    private getBids(): void {
        //fetch the bids for this storage offer
        this.refreshBids().finally(() => {
            // TODO Handle finish
            if (this.$location.hash()) {
                this.scrollTo(this.$location.hash());
            }
            if (!!this.editBidId) {
                this.startEditBid(this.editBidId);
            }
            this.longTermContractsVisible = this.checkLongTermContracts(
                this.offerBids
            );
        });
    }

    private checkLongTermContracts(offerBids: StorageOfferBidDto[]): boolean {
        let returnValue: boolean = false;
        angular.forEach(offerBids, (offerBid) => {
            angular.forEach(offerBid.productBids, (productBid) => {
                if (!!productBid.storageContractType) {
                    returnValue = true;
                }
            });
        });
        return returnValue;
    }

    private scrollTo(anchorId: string) {
        this.$timeout(() => {
            let old = this.$location.hash();
            this.$location.hash(anchorId);
            this.$anchorScroll();
            this.$location.hash(old);
        }, 500);
    }

    public goToPlaceBidSection(): void {
        this.scrollTo('place-a-bid');
    }

    public startEditBid(bidId: string) {
        this.editBidId = bidId;
        this.scrollTo('edit-bid-' + bidId);
    }

    public deleteBid(bidToBeDeleted: any): void {
        this.deletionLoading = true;
        this.deletionError = false;
        this.deletionSuccess = false;

        if (this.offer.actions.indexOf('DELETE') !== -1) {
        }
        this.storageOfferResource
            .deleteBid(
                { id: bidToBeDeleted.id },
                () => {
                    this.getBids();

                    this.deletionError = false;
                    this.deletionSuccess = true;

                    this.$rootScope.$broadcast(this.deletionEventName.SUCCESS);
                },
                (err: any) => {
                    this.$rootScope.$broadcast(this.deletionEventName.ERROR);

                    this.deletionError = true;
                    this.deletionSuccess = false;

                    const errorMessage =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'An unknown error occurred. Please, check back later.';
                    this.deletionErrMsg = errorMessage;
                }
            )
            .$promise.finally(() => (this.deletionLoading = false));
    }

    public getOfferProductById(id: number): StorageProductDto {
        return this.offer.products.find(
            (product: StorageProductDto) => product.id === id
        );
    }

    public changeOrder(newSortColumn: string): void {
        if (this.sortColumn === newSortColumn) {
            this.sortAscending = !this.sortAscending;
        } else {
            this.sortColumn = newSortColumn;
            this.sortAscending = true;
        }
    }

    public offerBidStateClass(
        offer: StorageOfferDto,
        offerBid: StorageOfferBidDto
    ): string {
        if (
            offer.state == 'PUBLISHED' ||
            offer.state == 'OPEN' ||
            (offer.state == 'FINISHED' &&
                offer.allocationMethod == 'NO_ALLOCATION') ||
            offer.allocationState != 'ALLOCATIONS_ACCEPTED'
        ) {
            if (offer.allocationState == 'ALLOCATIONS_REJECTED') {
                return 'fa fa-2x fa-times-circle text-danger';
            }

            return 'fa fa-2x fa-circle-o text-info';
        }

        if (
            offer.state == 'FINISHED' &&
            offer.allocationMethod != 'NO_ALLOCATION' &&
            offer.allocationState == 'ALLOCATIONS_ACCEPTED'
        ) {
            let numberOfProductBids: number = offerBid.productBids.length;
            let numberOfAllocatedProductBids = 0;
            let listOfFullyAllocatedBids = [];

            angular.forEach(
                offerBid.productBids,
                (productBid: StorageProductBidDto) => {
                    if (
                        productBid.productBidAllocation &&
                        productBid.productBidAllocation.allocatedQuantityValue >
                            0
                    ) {
                        numberOfAllocatedProductBids++;
                        if (
                            productBid.maxQuantityValue ==
                            productBid.productBidAllocation
                                .allocatedQuantityValue
                        ) {
                            listOfFullyAllocatedBids.push(productBid);
                        }
                    }
                }
            );

            if (numberOfAllocatedProductBids == 0) {
                return 'fa fa-2x fa-times-circle text-danger';
            }

            if (listOfFullyAllocatedBids.length < numberOfProductBids) {
                return 'fa fa-2x fa-minus-circle text-warning';
            }

            if (listOfFullyAllocatedBids.length == numberOfProductBids) {
                return 'fa fa-2x fa-check-circle text-success';
            }
        }
    }

    public onCanceledUpdateBid() {
        this.editBidId = null;
    }
}

angular.module('app').component('pkpStorageOfferBids', {
    controller: StorageOfferBidsComponentCtrl,
    template: require('app/storage-offer-bid/storage-offer-bids.component.html'),
    bindings: {
        offer: '<',
        offerBids: '<',
        offerBidsPreviousRound: '<',
        allocationEditModeActive: '<',
        allocationEditDisabled: '<',
        toggleEdit: '&',
        cancelEditOfferBids: '&',
        submitEditOfferBids: '&',
        loggedInUser: '<',
        refreshBids: '&',
        allocationsVisible: '<',
        editBidId: '='
    }
});
